import React from "react";
import PhleboAdminDashboardLeft from "../../PhleboAdmin/dashboard-left";
import PhleboAdminDashboardRight from "../../PhleboAdmin/dashboard-right";
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
    container: {
        display: 'flex',
        padding: "20px"
    }
});

interface Props {
    children: any;
}

const PhleboAdminDash: React.FC<Props> = ({ children }) => {
    const classes = useStyles();
    return (
        <div className={classes.container}>
            <PhleboAdminDashboardLeft />
            <PhleboAdminDashboardRight>{children && children}</PhleboAdminDashboardRight>
        </div>
    );
};

export default PhleboAdminDash;

